export default "__VITE_ASSET__BvdO2CzU__"